
import React, { Component, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Facebookfeed from './Facebook/facebookfeed';
import Instagramfeed from './Instagram/instagramfeed';
import Pinterest from './Pinterest/pinterest';
import TwitterFeed from './Twitter/twitterFeed';
import Airbnb from './Airbnb/airbnb';
import Youtube from './Youtube/youtube';
import Tumblr from './Tumblr/tumblr';
import Rss from './Rss/rss';
import Flickr from './Flickr/flickr';
import Googlefeed from './Googlereviews/googlefeed';
import Vimeofeed from './Vimeo/vimeofeed';
import Tiktokfeed from './Tiktok/tiktokfeed';
import Vkontaktefeed from './vkontakte/vkontaktefeed';
import { createFeedAction } from '../../../../../actions/addFeedActions';
import { connect } from 'react-redux';
import Linkedinfeed from './Linkedin/linkedinfeed';
import Yelpfeed from './Yelp/yelpfeed';
import WorkPlacefeed from './Workplace/workPlacefeed';
import Yammerfeed from './Yammer/yammerfeed';
import Slackfeed from './Slack/slackfeed';
import Giphy from './Giphy/giphy';
import { MediaBaseUrl } from '../../../../../actions/api';
import { closePricingModal } from '../../../../../utils/close_modal';
import { baseUrl } from '../../../../../utils';
import ConnectAccount from './Elements/ConnectAccount';
import Bluesky from './Bluesky';
import Thread from './Thread';


const CreateFeed = (props) => {
    const navigation = useNavigate();

    return <CF {...props} navigation={navigation} />;
}

const CreateFeedComponent = (props) => {
    const { feedInfo, networkId, updateFeedPostBody, updateConnectedAccountList } = props;
    const wallId = localStorage.getItem('wallId');

    useEffect(() => {
        updateFeedPostBody({});
        updateConnectedAccountList([]);
    }, [networkId]);

    switch (networkId) {
        case 1:
            return feedInfo ? <TwitterFeed {...props} wallId={wallId} /> : null

        case 18:
            return feedInfo ? <Instagramfeed {...props} wallId={wallId} /> : null

        case 3:
            return feedInfo ? <Facebookfeed {...props} wallId={wallId} /> : null

        case 5:
            return feedInfo ? <Pinterest {...props} wallId={wallId} /> : null

        case 23:
            return feedInfo ? <Airbnb {...props} wallId={wallId} /> : null

        case 7:
            return feedInfo ? <Youtube {...props} wallId={wallId} /> : null

        case 11:
            return feedInfo ? <Tumblr {...props} wallId={wallId} /> : null

        case 12:
            return feedInfo ? <Rss {...props} wallId={wallId} /> : null

        case 6:
            return feedInfo ? <Flickr {...props} wallId={wallId} /> : null

        case 4:
            return feedInfo ? <Googlefeed {...props} wallId={wallId} /> : null

        // case 29:
        //     return feedInfo ? <Onsitefeed feedInfo={feedInfo} networkId={id} hideAddfeed={onHideFeed} onBack={onBack} onFilterNameChange={onFilterNameChange} wallId={wallId} /> : null

        case 8:
            return feedInfo ? <Vimeofeed {...props} wallId={wallId} /> : null

        case 28:
            return feedInfo ? <Tiktokfeed {...props} wallId={wallId} /> : null

        case 30:
            return feedInfo ? <Vkontaktefeed {...props} wallId={wallId} /> : null

        case 10:
            return feedInfo ? <Linkedinfeed {...props} wallId={wallId} /> : null

        case 19:
            return feedInfo ? <Yelpfeed {...props} wallId={wallId} /> : null

        case 15:
            return feedInfo ? <WorkPlacefeed {...props} wallId={wallId} /> : null

        case 21:
            return feedInfo ? <Yammerfeed {...props} wallId={wallId} /> : null

        case 20:
            return feedInfo ? <Slackfeed {...props} wallId={wallId} /> : null

        case 26:
            return feedInfo ? <Giphy {...props} wallId={wallId} /> : null

        case 31:
            return feedInfo ? <Bluesky {...props} wallId={wallId} /> : null

        case 32:
            return feedInfo ? <Thread {...props} wallId={wallId} /> : null
            
        default:
            return <>network id - {networkId}</>
    }
}

class CF extends Component {
    state = {
        modalShow: true,
        filterName: "",
        showDownloadSample: false,
        loading: false,
        accountList: [],
        feedObj: {}
    }
    clickToToggleModal = () => {
        this.setState({
            modalShow: !this.state.modalShow
        })
    }

    onFilterNameChange = (value) => this.setState({ filterName: value });

    updateFeedPostBody = (obj) => this.setState({ feedObj: obj });

    updateConnectedAccountList = (list) => this.setState({ accountList: list });

    onHideFeed = () => this.props.closeModal()

    createFeedFromPage = (accId, parentId, name) => {
        let { feedObj } = this.state;
        const { network, navigation } = this.props;
        const networkId = network.networkId;
        const wallId = localStorage.getItem('wallId');
        
        if (networkId == 3) {
            feedObj = { ...feedObj, account: accId, connetedAccount: parentId }
        } else if (networkId == 18) {
            if ([34, 24, 25, 66, 88].includes(parseInt(feedObj.filter))) {
                feedObj.feedText = name;
                feedObj.accountId = accId;
            }else{
                feedObj.accountId = parentId;
            }
        }

        this.setState({ loading: true });
        createFeedAction(feedObj, networkId, (feedId) => this.setState({ loading: false }, () => {
            if (feedId) {
                this.onHideFeed();
                navigation(`/moderation/index/${wallId}`);
            }
        })
        );
    }

    render() {
        const { network, connectedAcc } = this.props;
        const { filterName, showDownloadSample, accountList, loading } = this.state

        return (
            <>{
                (accountList && accountList.length > 0) ?
                    <ConnectAccount accountList={accountList} loading={loading} connectedAcc={connectedAcc} networkId={network.networkId} createFeedFromPage={this.createFeedFromPage} onBack={() => this.setState({ accountList: [] })} /> :
                    !showDownloadSample ? <div className="add-feed-modal-body">
                        <div className="container">
                            <div id="feed_content__">
                                <form className="maintainPopUp noLoader" id="feedPostUrlForm">
                                    <div className="small_container">
                                        <div className="middle_content">
                                            <div id="create_feed_section" className="card card-custom card-body p-4">
                                                <div className="pt-0">
                                                    <div className="d-flex flex-wrap align-items-center mb-3">
                                                        <div className="symbol symbol-60 flex-shrink-0 me-4">
                                                            <div className="symbol-label" style={{ backgroundImage: `url(${MediaBaseUrl}square-icons/${network.networkCode=="twitter"?`${network.networkCode}X`:network.networkCode}.svg)` }}></div>
                                                        </div>
                                                        <h4 className="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                                                            <span className="card-label font-weight-bolder text-dark">{network.networkName}</span>
                                                            <span className="mt-1 font-weight-bold font-size-sm">Add your {network.networkName} <span id="changeTxt">{filterName}</span></span>
                                                        </h4>
                                                    </div>
                                                </div>
                                                <CreateFeedComponent networkId={network.networkId} {...this.props} hideAddfeed={this.onHideFeed} onFilterNameChange={this.onFilterNameChange} updateFeedPostBody={this.updateFeedPostBody} updateConnectedAccountList={this.updateConnectedAccountList} toggleDownloadView={(value) => this.setState({ showDownloadSample: value })} />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div> : <div id="download_sample" className='Sample_xml_preview'>
                        <div className='col-md-12 my-8 text-center'>
                            <img src={baseUrl(`downloads/sample-design--xml-rss-feed.png`)} className='img-fluid' />
                        </div>
                        <div className='col-md-12 form-group text-center pt-5'>
                            <button type='button' className='btn btn-secondary mr-2' onClick={() => this.setState({ showDownloadSample: false })}>Back</button>
                            <a href='/assets/downloads/sample-xml.txt' download="sample-xml.txt" className='btn btn-primary'>Download Sample</a>
                        </div>
                    </div>}
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        accounts: state.addFeedReducer,
        connectedAcc: state.addFeedReducer.connectedAcc,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        closeModal: () => closePricingModal(dispatch),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateFeed);